import React, {
    useCallback, useContext, useEffect, useState
} from 'react';
import {
    get, set, isEqual
} from 'lodash';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import metadata from '../VehiclesPage.metadata.json5';

function ViewVehiclesPage(props) {
    const {
        wizardData: renewalVM,
        updateWizardData,
        viewOnly
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const [pageInitialized, setIsPageInitialized] = useState(false);
    const [checkScrolling, setCheckScrolling] = useState(false);
    const [availableMakes, setAvailableMakes] = useState({});
    const [availableModels, setAvailableModels] = useState({});
    const [availableSeries, setAvailableSeries] = useState({});

    const {
        onValidate,
        isComponentValid
    } = useValidation('VehiclePage');
    const { authHeader } = useAuthentication();

    renewalVM.flowStepIDs_Ext.value = ['vehicle'];
    renewalVM.entryCompletionStepIDs_Ext.value = ['vehicle'];

    /**
     * Helper callback for handling navigation to the next wizard screen.
     */
    const onNext = useCallback(() => renewalVM, [renewalVM]);

    /**
     * Helper effect for handling the component initialization logic.
     */
    useEffect(() => {
        if (!pageInitialized) {
            const vehiclesPath = 'lobData.personalAuto_EA.coverables.vehicles';
            const vehicles = get(renewalVM, `${vehiclesPath}.value`);

            const newVehicles = vehicles.map((vehicle) => {
                const newVehicle = {
                    ...vehicle,
                    vin: vehicle.vin,
                    costNew: vehicle.costNew
                };
                
                return newVehicle;
            });

            // Update the submission VM with new list of vehicles
            if (!isEqual(newVehicles, vehicles)) {
                set(renewalVM, `${vehiclesPath}.value`, newVehicles);
                updateWizardData(renewalVM);
            }

            setIsPageInitialized(true);
        }
        // eslint - disable - next - line max - len
    }, [pageInitialized, renewalVM, updateWizardData]);

    /**
     * Define property overrides for this Jutro component.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showOptional: true,
            labelPosition: 'top',
            disable: viewOnly
        },
        vehiclesPageLoadingIndicator: {
            loaded: true
        },
        vehicleLookupErrorNotificationDiv: {
            visible: false
        },
        vehiclesPageContainer: {
            visible: true
        },
        addVehicle: {
            disabled: !isComponentValid
        },
        eaAddAnotherVehicleButtonContainer: {
            visible: false
        },
        vehicleInformationSubHeaderID: {
            visible: false
        },
        scrollingComponentId: {
            checkScrolling,
            setCheckScrolling,
            scrollableDiv: document.getElementById('eavehiclecontainerID')
        },
        oneCarMinimumNotificationDiv: {
            visible: false
        },
        fieldsClearedInfoMessage: {
            visible: false
        },
        yearVinInvalidInfoMessage: {
            visible: false
        },
        vehicleInfoChangedMessageDiv: {
            visible: false
        },
        EAVehicleGrid: {
            vehicles: get(renewalVM, 'lobData.personalAuto_EA.coverables.vehicles', []),
            path: 'lobData.personalAuto_EA.coverables.vehicles.children',
            onValidate,
            viewModelService,
            showErrors: false,
            policyState: get(renewalVM, 'baseData.policyAddress.state.value.code'),
            vehiclePageDisregardFieldValidation: () => {},
            authHeader,
            onValidationChange: onValidate,
            transactionVM: renewalVM,
            updateWizardData,
            setCheckScrolling,
            addVehicleVM: () => {},
            viewOnlyMode: true,
            availableMakes,
            setAvailableMakes,
            availableModels,
            setAvailableModels,
            availableSeries,
            setAvailableSeries
        }
    };

    /**
     * Helper callback for reading values from the view model.
     */
    const readValue = useCallback(
        (id, path) => readViewModelValue(
                metadata.pageContent,
                renewalVM,
                id,
                path,
                overrideProps
            ),
        [renewalVM, overrideProps]
    );

    /**
     * Define mappings to be used when resolving values for this Jutro component.
     */
    const resolvers = {
        resolveCallbackMap: {
            onAddVehicleClick: () => { },
            onAddAdditionalInterest: () => { },
            onRemoveVehicle: () => { },
            onValidate,
            onPrefillData: undefined,
            onGaragingAddressChange: () => { },
            onVehicleLookupError: () => { }
        }
    };

    /**
     * Define rendering behaviors for this Jutro component.
     */
    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={renewalVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

ViewVehiclesPage.propTypes = wizardProps;
export default ViewVehiclesPage;
